import { getAuthentication } from '@/api/auth/authApi';
import { createQueryHook } from '@/lib/adapters/react-query-adapter';
import { QueryKeys } from '@/lib/constants/query-keys';
import { type AuthUser } from '@/schemas/auth-user';

export const useAuthentication = createQueryHook<AuthUser, Error, [QueryKeys.AUTHENTICATION]>(
  [QueryKeys.AUTHENTICATION],
  getAuthentication,
  { refetchOnWindowFocus: 'always' }
);
